<template>
  <div class="section-review-column-container">
    <section-review-column
      v-for="(column, index) in columns"
      :key="index"
      :flashcard-list-statuses="column.statuses"
      :first-question-number="column.firstQuestionNumber"
      :is-simulation-complete="isSimulationComplete"
      :show-section-name="showSectionName"
      @navigate="handleNavigate"
    />
  </div>
</template>

<script>
import SectionReviewColumn from '@components/sims/sectionReview/SectionReviewColumn.vue';

export default {
  components: {
    SectionReviewColumn,
  },
  props: {
    numberOfColumns: {
      type: Number,
      default: 3,
    },
    flashcardListStatuses: {
      type: Array,
      required: true,
    },
    isSimulationComplete: {
      type: Boolean,
      required: true,
    },
    showSectionName: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['navigate'],
  computed: {
    columns() {
      const columns = [];
      const itemsPerColumn = Math.ceil(this.flashcardListStatuses.length / this.numberOfColumns);

      for (let i = 0; i < this.numberOfColumns; i++) {
        const startIndex = i * itemsPerColumn;
        const endIndex = Math.min((i + 1) * itemsPerColumn, this.flashcardListStatuses.length);
        const statuses = this.flashcardListStatuses.slice(startIndex, endIndex);

        if (statuses.length > 0) {
          columns.push({
            statuses,
            firstQuestionNumber: startIndex + 1,
          });
        }
      }

      return columns;
    },
  },
  methods: {
    handleNavigate(flashcardId, filter) {
      this.$emit('navigate', flashcardId, filter);
    },
  },
};
</script>

<style lang='scss' scoped>
.section-review-column-container {
  margin-top: 3rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
</style>
